import { toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';

var sortResultsByType = function sortResultsByType(results, typeOrdering) {
  return _toConsumableArray(results).sort(function (a, b) {
    if (typeOrdering.indexOf(a.resultType) < typeOrdering.indexOf(b.resultType)) return -1;
    if (typeOrdering.indexOf(a.resultType) > typeOrdering.indexOf(b.resultType)) return 1;
    return 0;
  });
};

export { sortResultsByType as default };
//# sourceMappingURL=sortResults.js.map
